import { render, staticRenderFns } from "./TabDossierHours.vue?vue&type=template&id=02c58a08"
import script from "./TabDossierHours.vue?vue&type=script&setup=true&lang=js"
export * from "./TabDossierHours.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports